




















































import mixins from 'vue-typed-mixins'
import { throttle } from 'lodash-es'
import { registerHeightObserver, unregisterHeightObserver } from 'element-height-observer'

import utils from 'utils'
import stays from '@store/stays'
import { Stay } from 'models/data/stay'
import { ViewMode } from 'models/meta'
import { FullSchema } from 'models/schema/stay'

import DelayRouteLeaveMixin from '@shared/DelayRouteLeaveMixin.vue'
import Sidebar from "./SideBar.vue"
import StaySummary from "./StaySummary.vue"

export default mixins(DelayRouteLeaveMixin).extend({
    components: {
        Sidebar,
        StaySummary
    },
    props: {
        stay_id: {
            type: Number,
            required: true
        },
        viewMode: {
            required: false,
            default: ViewMode.normal,
        },
    },
    data() {
        return {
            htmlID: `${utils.getUID()}___dataentry`,
            /** flag indicating if scroll is being monitored */
            monitorScroll: false,
            canScrollDown: false,
            loadWaiter: 0,
            loaded: false,
            sidebarVisible: true,
            notesBtnVisible: false,
            notesDocked: false,
        }
    },
    computed: {
        betaEnabled(): boolean {
            return this.$store.direct.getters.user.betaEnabled
        },
        stay(): Stay | undefined {
            return stays.state.stays[this.stay_id]
        },
        fullSchema(): FullSchema | null {
            return this.$store.direct.state.stays_v2.fullSchema
        },
        ready(): boolean {
            return this.stay !== undefined
        },
        hasUnsavedChanges(): boolean  {
            return stays.state.stayChanged
        },
        sidebarBtnText(): string {
            return this.sidebarVisible ? 'Hide sidebar' : 'Show sidebar'
        },
    },
    watch: {
        stay_id: {
            handler: function(newVal, oldVal) {
                if (oldVal)
                    stays.mutClearStay(oldVal)
                this.loadStay()
            },
            immediate: true
        },
        ready(val) {
            if (val) {
                if (!this.monitorScroll) {
                    this.$nextTick(() => {
                        const appElem = document.getElementById(this.htmlID)
                        if (appElem) {
                            this.calculateScroll()
                            registerHeightObserver(appElem, () => {
                                this.calculateScroll()
                            })
                            appElem.onscroll = throttle(() => {this.calculateScroll()}, 250)
                            this.monitorScroll = true
                        }

                    })
                }
            }
        },
        $route() {
            this.notesBtnVisible = false
        },
    },
    beforeCreate() {
        stays.mutClearAll()
    },
    mounted() {
        window.scrollTo(0, 0)
        document.documentElement.className += ' overflow-hidden'
    },
    beforeDestroy() {
        this.stopLoadWaiter()
        if (this.monitorScroll) {
            const appElem = document.getElementById(this.htmlID)
            if (appElem) {
                unregisterHeightObserver(appElem)
                appElem.onscroll = null
            }
        }
        this.monitorScroll = false
        document.documentElement.className = document.documentElement.className.replace(' overflow-hidden', '')
        stays.mutClearStay(this.stay_id)
    },
    methods: {
        $_loadStay() {
            this.loaded = false
            stays.actPullStay(this.stay_id)
            .then(res => {
                this.loaded = true
            })
        },
        loadStay() {
                if (this.fullSchema)  // so that loading happens immediately if schema is ready
                    this.$_loadStay()
                else {
                    this.loadWaiter = window.setInterval(() => {
                        if (this.fullSchema) {
                            this.stopLoadWaiter()
                            this.$_loadStay()
                        }
                    }, 250)
                }
        },
        stopLoadWaiter() {
            if (this.loadWaiter) {
                clearInterval(this.loadWaiter)
                this.loadWaiter = 0
            }
        },
        calculateScroll() {
            const appElem = document.getElementById(this.htmlID)
            if (appElem) {
                const scrolledY = appElem.scrollHeight - appElem.scrollTop
                const diff = Math.abs(scrolledY - appElem.clientHeight)
                this.canScrollDown = diff > 5
            }
        },
        toggleSidebar(): void {
            this.sidebarVisible = !this.sidebarVisible
        },
        toggleNotesDocked(): void {
            this.notesDocked = !this.notesDocked
        },
    }
})
